import Button from './Button'
import LoadingButton from './LoadingButton'

export { LoadingButton }
export default Button
